import React from "react";
import styles from "./ExpandArea.module.sass";
import { Collapse } from "react-bootstrap";

const expandArea = (props) => {
  return (
    <div className={styles.ExpandArea + " " + (props.open ? styles.open : "")}>
      <div
        onClick={() => props.onClick(props.index, !props.open)}
        className={`${styles.Title} ${props.open ? styles.open : ""}`}
      >
        <label className={props.open || props.container ? styles.open : ""}>
          {props.title}
        </label>
        <i
          className={
            !props.open ? "icon icon-seta-baixo-p" : "icon icon-seta-cima-p"
          }
        />
      </div>
      <Collapse in={props.open}>{props.children}</Collapse>
    </div>
  );
};

export default expandArea;
